import ReactDOM from 'react-dom';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FLEET_BILLING_MODE } from '../../../utils/constants';

const INLINE_BANNER_STYLE = {
  backgroundColor: '#FEF0C7',
  padding: '10px',
  marginBottom: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const FIXED_BANNER_STYLE = {
  backgroundColor: '#FEF0C7',
  padding: '10px 20px',
  marginBottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  minHeight: 64,
  maxHeight: 72,
  zIndex: 1040,
  boxSizing: 'border-box',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
};

const WarningBilling = ({
  onTopup,
  billingUsage,
  variant = 'inline',
  topOffset = 0,
}) => {
  if (billingUsage?.billingMode === FLEET_BILLING_MODE.invoice) return null;
  const isLowBalance =
    (billingUsage?.creditBalance || 0) + (billingUsage?.cashBalance || 0) < 0;
  if (!isLowBalance) return null;

  const fixedStyle =
    variant === 'fixed'
      ? { ...FIXED_BANNER_STYLE, top: topOffset || 0 }
      : null;

  const banner = (
    <div
      style={variant === 'fixed' ? fixedStyle : INLINE_BANNER_STYLE}
      role="status"
    >
      <p style={{ marginBottom: 0 }}>
        <span style={{ fontWeight: 'bold' }}>Low Balance Alert</span> — Please
        top up your credits to continue creating orders.
      </p>
      <Button
        style={{
          backgroundColor: '#FDB022',
          color: '#fff',
          fontWeight: '700',
          fontSize: '14px',
        }}
        onClick={onTopup}
      >
        Top up
      </Button>
    </div>
  );

  if (variant === 'fixed') {
    return ReactDOM.createPortal(banner, document.body);
  }
  return banner;
};

export default WarningBilling;